import { cn } from "@omni/utils/styles";

import CalculationField from "@/components/Calculator/Components/CalculationField/calculationField.component";
import { Dropdown } from "@/components/General/Dropdown/dropdown.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { DamImage } from "@/utils/dam.utils";

import { CalculatorImage } from "../../Components/CalculatorImage/calculatorImage.component";

type Props = {
    setCalculationValue: (name: string, value: string) => void;
    setBrickMeasurements: (
        brickLength: number,
        brickWidth: number,
        brickHeight: number
    ) => void;
    wallLength: number;
    wallHeight: number;
    brickLength: number;
    brickWidth: number;
    brickHeight: number;
};

const Calculation = ({
    setCalculationValue,
    setBrickMeasurements,
    wallLength,
    wallHeight,
    brickLength,
    brickWidth,
    brickHeight
}: Props) => {
    const { t } = useGranite();

    return (
        <div>
            <Row>
                <Col className={"col-xs-12 col-md-8"}>
                    <h3>{t("calculator.brickCalculator.measurementWall")}</h3>
                    <Row>
                        <CalculationField
                            name={"wallLength"}
                            dimension={"length"}
                            unit={"m"}
                            setCalculationValue={setCalculationValue}
                            {...(wallLength && { value: wallLength })}
                            sm={8}
                            md={6}
                            lg={4}
                        />
                        <CalculationField
                            name={"wallHeight"}
                            dimension={"height"}
                            unit={"m"}
                            setCalculationValue={setCalculationValue}
                            {...(wallHeight && { value: wallHeight })}
                            sm={8}
                            md={6}
                            lg={4}
                        />
                    </Row>
                    <h3 className={cn("tw:mt-6")}>
                        {t("calculator.brickCalculator.measurementBricks")}
                    </h3>
                    <Dropdown
                        placement={"bottom"}
                        isLabel={true}
                    >
                        <Dropdown.Toggle color={"primary"}>
                            <Dropdown.Label>
                                {t(
                                    "calculator.brickCalculator.defaultMeasurements"
                                )}
                            </Dropdown.Label>
                            <Dropdown.Caret className={"ml-2"} />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Header>
                                {t("calculator.brickCalculator.concreteBlock")}
                            </Dropdown.Header>
                            <Dropdown.Item
                                onClick={() => setBrickMeasurements(39, 9, 19)}
                                label="39 x 9 x 19"
                            />
                            <Dropdown.Item
                                onClick={() => setBrickMeasurements(39, 14, 19)}
                                label="39 x 14 x 19"
                            />
                            <Dropdown.Item
                                onClick={() => setBrickMeasurements(39, 19, 19)}
                                label="39 x 19 x 19"
                            />
                            <Dropdown.Divider />
                            <Dropdown.Header>
                                {t(
                                    "calculator.brickCalculator.rapidConstruction"
                                )}
                            </Dropdown.Header>
                            <Dropdown.Item
                                onClick={() => setBrickMeasurements(29, 9, 14)}
                                label="29 x 9 x 14"
                            />
                            <Dropdown.Item
                                onClick={() => setBrickMeasurements(29, 14, 14)}
                                label="29 x 14 x 14"
                            />
                            <Dropdown.Item
                                onClick={() => setBrickMeasurements(29, 9, 19)}
                                label="29 x 9 x 19"
                            />
                            <Dropdown.Item
                                onClick={() => setBrickMeasurements(29, 19, 14)}
                                label="29 x 19 x 14"
                            />
                            <Dropdown.Divider />
                            <Dropdown.Header>
                                {t("calculator.brickCalculator.boerke")}
                            </Dropdown.Header>
                            <Dropdown.Item
                                onClick={() =>
                                    setBrickMeasurements(19, 8.5, 6.5)
                                }
                                label="19 x 8,5 x 6,5"
                            />
                            <Dropdown.Divider />
                            <Dropdown.Header>
                                {t("calculator.brickCalculator.rhineShape")}
                            </Dropdown.Header>
                            <Dropdown.Item
                                onClick={() => setBrickMeasurements(18, 8.5, 5)}
                                label="18 x 8,5 x 5"
                            />
                        </Dropdown.Menu>
                    </Dropdown>
                </Col>
                <Col className={"col-md-4 d-flex text-center align-items-end"}>
                    <CalculatorImage
                        className={cn("tw:mt-3")}
                        src={DamImage.calculator.bricks}
                        alt={"baksteen.jpg"}
                    />
                </Col>
            </Row>
            <Row className={"mt-4"}>
                <CalculationField
                    name={"brickLength"}
                    dimension={"length"}
                    unit={"cm"}
                    setCalculationValue={setCalculationValue}
                    {...(brickLength && {
                        value: brickLength.toString().replace(".", ",")
                    })}
                    sm={4}
                    md={3}
                    lg={2}
                />
                <CalculationField
                    name={"brickWidth"}
                    dimension={"width"}
                    unit={"cm"}
                    setCalculationValue={setCalculationValue}
                    {...(brickWidth && {
                        value: brickWidth.toString().replace(".", ",")
                    })}
                    sm={4}
                    md={3}
                    lg={2}
                />
                <CalculationField
                    name={"brickHeight"}
                    dimension={"height"}
                    unit={"cm"}
                    setCalculationValue={setCalculationValue}
                    {...(brickHeight && {
                        value: brickHeight.toString().replace(".", ",")
                    })}
                    sm={4}
                    md={3}
                    lg={2}
                />
            </Row>
        </div>
    );
};

export default Calculation;
